import { FormSuccess } from 'Components/Form/Success';
import { PageHelper } from 'Components/PageHelper';
import { StepperForm } from 'Components/StepperForm';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '../../../Components/Container';
import { Detalhes } from './Details';
// import { Dados } from './Datas';
import { Vinculos } from './Bonds';
import { useEffect } from 'react';
import { Row } from 'Components/Grid';
import { TitleForm } from 'Components/Form/styles';
/** Services */
import { addProcess, editProcess, getProcessById } from 'services/processes-service';
/** State Managers */
import { useAuthTenant } from 'store/auth';
import { useSelector } from 'react-redux';
/** Third Lib Modal */
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useQuery } from 'react-query';
import { PageLoaderForm } from 'Components/PageLoader/Form';
import { useTranslation } from 'react-i18next';

export const ProcessesForm = () => {
  const { t } = useTranslation('mapping');
  const steps = [t('processes.form.detailsStep'), t('processes.form.bondsStep')];
  const selectedTenant = useSelector(useAuthTenant);
  const { id } = useParams();
  const SwalReact = withReactContent(Swal);
  const navigate = useNavigate();
  const [idProcess, setIdProcess] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [finished, setFinished] = useState(false);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      criticity: '',
      user: '',
      tags: [],
      description: '',
      descriptionDataFlow: '',
      dpia: false,
      lia: false,
      dataTreatmentFromChildrenTeenagerElderly: false,
      areas: [],
      systems: [],
      assets: [],
      dataMapping: [],
      companyKey: selectedTenant.slug,
    },
  });

  const totalSteps = () => {
    return steps.length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const handleNext = () => {
    const newActiveStep = isLastStep() ? activeStep : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const formatArea = area => {
    return {
      _id: area._id,
      name: area.name,
      description: area.description,
      user: area.user,
      criticity: area.criticity,
    };
  };

  const formatAsset = asset => {
    return {
      _id: asset._id,
      name: asset.name,
      description: asset.description,
      user: asset.user,
      criticity: asset.criticity,
    };
  };

  const formatSystem = system => {
    return {
      _id: system._id,
      name: system.name,
      description: system.description,
      criticity: system.criticity,
      user: system.user,
    };
  };

  const formatForm = dados => {
    return {
      name: dados.name,
      criticity: dados.criticity,
      user: dados.user,
      tags: dados.tags.length > 0 ? dados.tags : [],
      description: dados.description,
      descriptionDataFlow: dados.descriptionDataFlow,
      dpia: dados.dpia ?? false,
      lia: dados.lia ?? false,
      dataTreatmentFromChildrenTeenagerElderly: dados.dataTreatmentFromChildrenTeenagerElderly ?? false,
      areas: dados.areas.length > 0 ? dados.areas.map(area => formatArea(area)) : [],
      systems: dados.systems.length > 0 ? dados.systems.map(system => formatSystem(system)) : [],
      assets: dados.assets.length > 0 ? dados.assets.map(asset => formatAsset(asset)) : [],
      dataMapping: dados.dataMapping.length > 0 ? dados.dataMapping : [],
      companyKey: dados.companyKey ?? selectedTenant.slug,
    };
  };

  const handleComplete = async () => {
    try {
      setIsLoadingForm(true);
      const formattedForm = formatForm(getValues());
      const res = id ? await editProcess(id, formattedForm) : await addProcess(formattedForm);
      if (res.status === 200 || res.status === 201) {
        setIdProcess(res.data._id ?? id);
        setFinished(true);
        setIsLoadingForm(false);
      } else {
        throw new Error(t('processes.form.errorSave'));
      }
    } catch (error) {
      setIsLoadingForm(false);
      SwalReact.fire({
        title: t('processes.toasts.errorTitle'),
        text: error.response.data.message ?? error.message,
        icon: 'error',
      });
    }
  };

  const handleReset = () => {
    reset();
    setActiveStep(0);
    setFinished(false);
    setIdProcess(null);
    navigate('/processes/add');
  };

  const getTitleStep = () => {
    if (finished) return <></>;

    if (activeStep === 0)
      return (
        <Row>
          <TitleForm>{t('processes.form.detailsTitle')}</TitleForm>
        </Row>
      );

    return (
      <Row>
        <TitleForm>{t('processes.form.bondsTitle')}</TitleForm>
      </Row>
    );
  };

  const {
    isLoading,
    error,
    data: process,
  } = useQuery(['getProcess', id], async () => {
    if (!id) return null;

    const resProcess = await getProcessById(id);

    if (!resProcess.data) return null;

    return resProcess.data;
  });

  useEffect(() => {
    if (!id) return;
    if (!process) return;

    Object.keys(process).forEach(key => {
      setValue(key, process[key]);
    });

    return () => {};
  }, [id, process, setValue]);

  const showForm = () => {
    if (id) return !isLoading && !error;
    return true;
  };

  return (
    <Container
      title={t('processes.form.headerTitle', { action: id ? t('processes.form.actionEdit') : t('processes.form.actionAdd') })}
      breadcrumb={t('processes.show.breadcrumb', { name: '' })}
      linkPage="/processes"
      dataTour="page-title"
    >
      {isLoading && <PageLoaderForm />}
      {showForm() && (
        <>
          <div data-tour="stepper">
            <StepperForm activeStep={activeStep} steps={steps} />
          </div>
          <div className="card-content">
            {getTitleStep()}
            {activeStep === 0 && (
              <Detalhes
                control={control}
                register={register}
                handleNext={handleNext}
                handleSubmit={handleSubmit}
                errors={errors}
                getValues={getValues}
                id={id}
              />
            )}
            {activeStep === 1 && !finished && (
              <Vinculos
                control={control}
                register={register}
                handleBack={handleBack}
                handleComplete={handleComplete}
                handleSubmit={handleSubmit}
                isLoading={isLoadingForm}
              />
            )}
            {finished && (
              <FormSuccess
                title={t('processes.form.successMessage')}
                labelStartAgain={t('processes.form.addAnother')}
                handleStartAgain={() => handleReset()}
                labelShow={t('processes.form.viewDetails')}
                handleShow={() => navigate('/processes/show/' + idProcess)}
              />
            )}
          </div>
        </>
      )}
      {!finished && <PageHelper steps={tourSteps} tourKey="processes-form" />}
    </Container>
  );
};

// Tour steps
const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo ao formulário de Processos! Este formulário possui 2 etapas: Detalhes e Vínculos.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="page-title"]',
    content: 'Clique aqui no título para voltar à lista de processos.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="stepper"]',
    content: 'Este indicador mostra as 2 etapas do formulário: 1) Detalhes do processo, e 2) Vínculos com áreas, sistemas e ativos.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="process-name"]',
    content: 'Digite o nome do processo. Este campo identifica o processo de forma única.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="process-criticity"]',
    content: 'Selecione a criticidade do processo: de 1 (Muito Baixa) a 5 (Muito Alta). As cores ajudam na identificação visual.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="process-user"]',
    content: 'Selecione o responsável pelo processo. Esta pessoa será o ponto de contato principal.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="process-tags"]',
    content: 'Adicione tags para facilitar a busca e organização. Digite uma tag e pressione Enter para adicioná-la.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="process-description"]',
    content: 'Descreva o processo detalhadamente: objetivos, atividades e responsabilidades.',
  },
  {
    target: '[data-tour="process-dataflow"]',
    content: 'Descreva o fluxo de dados do processo: como os dados são coletados, processados e armazenados.',
  },
  {
    target: '[data-tour="process-checkboxes"]',
    content: 'Marque as opções aplicáveis: DPIA (Avaliação de Impacto), LIA (Interesse Legítimo) e tratamento de dados de grupos vulneráveis.',
  },
  {
    target: '[data-tour="form-actions"]',
    content: 'Use "Cancelar" para descartar as alterações ou "Salvar" para avançar para a próxima etapa.',
  },
  {
    target: 'body',
    content: 'Após preencher os detalhes, você poderá vincular áreas, sistemas e ativos na próxima etapa.',
    placement: 'center',
  },
];
